import { render, staticRenderFns } from "./PWR02G06_RO.vue?vue&type=template&id=f4afe824&scoped=true"
import script from "./PWR02G06_RO.vue?vue&type=script&lang=js"
export * from "./PWR02G06_RO.vue?vue&type=script&lang=js"
import style0 from "./PWR02G06_RO.vue?vue&type=style&index=0&id=f4afe824&lang=scss&scoped=true"
import style1 from "./PWR02G06_RO.vue?vue&type=style&index=1&id=f4afe824&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4afe824",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4afe824')) {
      api.createRecord('f4afe824', component.options)
    } else {
      api.reload('f4afe824', component.options)
    }
    module.hot.accept("./PWR02G06_RO.vue?vue&type=template&id=f4afe824&scoped=true", function () {
      api.rerender('f4afe824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pwr/PWR02G06_RO.vue"
export default component.exports